import React, { useState } from "react";
import {
  Card,
  Form,
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import UploadSection from "./UploadSection";
import {
  FaInfoCircle,
  FaEye,
  FaChevronRight,
  FaChevronDown,
} from "react-icons/fa";
import { NumericFormat } from "react-number-format";
import InputMask from "react-input-mask";
import History from "../../../../Analysis/ComponentsAnalysis/HistoryAdequacao/History";

const Topic = ({
  data,
  hasError,
  onFileUpload,
  idResposta,
  selectedOptions,
  setSelectedOptions,
  handleCampoChange,
  uploadedFiles,
  quantidadeAssociados,
  setQuantidadeAssociados,
  disabled,
  analysisValues = {},
  onAnalysisChange,
  historico,
  itensNaoConformes,
  modoAdequacao,
  tentouEnviar,
  isOpen: isOpenProp,
  onToggle: onToggleProp,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const [localOpen, setLocalOpen] = useState(false);
  const isControlled = isOpenProp !== undefined && typeof onToggleProp === "function";
  const isOpen = isControlled ? isOpenProp : localOpen;
  const handleToggle = isControlled ? onToggleProp : () => setLocalOpen((prev) => !prev);

  const handleShowModal = (description) => {
    setModalContent(description);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const getCampoKey = (campo, label, parentKey, idx) => {
    return (
      campo.idCampo ||
      `${data.id}-${parentKey || "root"}-${label}-${idx}`.trim()
    );
  };

  const mapHistoricoToInitialValue = (historicoItem) => {
    if (!historicoItem) return {};
    return {
      status:
        historicoItem.conforme === true
          ? "CONFORME"
          : historicoItem.conforme === false
            ? "NAO_CONFORME"
            : null,
      observacao: historicoItem.observacao || "",
      solicitadoEm: historicoItem.dataSolicitacao || "",
      obsAnalista: historicoItem.obsAnalista || "",
      adequadoEm: historicoItem.dataAdequacao || "",
      obsSindicato: historicoItem.obsSindicato || "",
      adequacaoRealizada: historicoItem.adequacaoRealizada || false,
    };
  };

  function slugify(text) {
    let slug = text
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
    slug = slug.replace(/^\d+-/, "");
    return slug;
  }

  const renderField = (campo, idx, parentKey = "") => {
    const tipo = campo.tipoCampo;
    const rawLabel = campo.titulo || campo.descricao || "";
    const label = rawLabel.replace(/\*/g, "").trim();
    const campoKey = getCampoKey(campo, label, parentKey, idx);
    const value =
      selectedOptions?.[data.id]?.campos?.[campoKey] ?? campo.resposta ?? "";
    const _nomeParaSlug =
      campo.nomeArquivo || campo.titulo || campo.idCampo || label;

    const slugKey = slugify(data.idCampoJson);

    const historicoItem = historico?.[slugKey];
    const emAdequacaoDesteCampo =
      modoAdequacao &&
      historicoItem?.dataSolicitacao &&
      !historicoItem?.dataAdequacao &&
      historicoItem?.adequacaoRealizada !== true;

    const handleChange = (val) => {
      setSelectedOptions((prev) => {
        const campos = { ...(prev?.[data.id]?.campos || {}) };
        return {
          ...prev,
          [data.id]: {
            ...prev?.[data.id],
            campos: {
              ...campos,
              [campoKey]: val,
            },
          },
        };
      });
      handleCampoChange(campoKey, val, data.id);
    };

    const isReceitaOperacional = label
      .toLowerCase()
      .includes("receita operacional");
    const isCNPJ = label.toLowerCase().includes("cnpj");
    const isRazaoSocial = label.toLowerCase().includes("razão social");

    if (tipo === "input" || tipo === "text") {
      if (isCNPJ) {
        const hasError = value && value.replace(/\D/g, "").length < 14;
        const _disabledCNPJ = modoAdequacao ? !emAdequacaoDesteCampo : disabled;
        return (
          <Form.Group key={idx} className="mt-3">
            <Form.Label className="fw-bold">{label}</Form.Label>
            <InputMask
              mask="99.999.999/9999-99"
              value={value}
              onChange={(e) => {
                let numericValue = e.target.value.replace(/\D/g, "");
                if (numericValue.length > 14)
                  numericValue = numericValue.slice(0, 14);
                handleChange(numericValue);
              }}
              disabled={modoAdequacao ? !emAdequacaoDesteCampo : disabled}
            >
              {(inputProps) => (
                <Form.Control
                  {...inputProps}
                  disabled={modoAdequacao ? !emAdequacaoDesteCampo : disabled}
                  type="text"
                  placeholder="00.000.000/0000-00"
                  isInvalid={hasError}
                />
              )}
            </InputMask>
            {hasError && (
              <Form.Control.Feedback type="invalid">
                CNPJ deve ter 14 dígitos.
              </Form.Control.Feedback>
            )}
          </Form.Group>
        );
      }
      if (isRazaoSocial) {
        return (
          <Form.Group key={idx} className="mt-3">
            <Form.Label className="fw-bold">{label}</Form.Label>
            <Form.Control
              type="text"
              placeholder="Digite a Razão Social"
              value={value}
              onChange={(e) => handleChange(e.target.value)}
              disabled={modoAdequacao ? !emAdequacaoDesteCampo : disabled}
            />
          </Form.Group>
        );
      }
    }

    if (tipo === "decimal") {
      return (
        <Form.Group key={idx} className="mt-3">
          <Form.Label className="fw-bold">
            {label}
            {isReceitaOperacional && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    Receita Operacional: aquela oriunda de ações que
                    efetivamente houve empenho da entidade. Como as
                    contribuições, prestação de serviços e demais que se
                    enquadrem nessa classificação. Receitas com aplicações
                    financeiras e subsídio, oferecido pela FIEMG não são receita
                    de caráter operacional para fins de cálculo.{" "}
                    <strong>
                      Em caso de dúvidas quanto ao valor da receita operacional,
                      recomenda-se consultar o contador do Sindicato.
                    </strong>
                  </Tooltip>
                }
              >
                <span>
                  <FaInfoCircle
                    className="ms-2 text-primary"
                    onClick={() => handleShowModal(campo.descricao)}
                    style={{ cursor: "pointer" }}
                  />
                </span>
              </OverlayTrigger>
            )}
          </Form.Label>
          <NumericFormat
            customInput={Form.Control}
            className={isReceitaOperacional ? "w-25" : ""}
            placeholder="R$ 000.000,00"
            value={value}
            onValueChange={(values) => handleChange(values.value)}
            thousandSeparator="."
            decimalSeparator=","
            prefix="R$ "
            allowNegative={false}
            decimalScale={2}
            fixedDecimalScale
            disabled={modoAdequacao ? !emAdequacaoDesteCampo : disabled}
          />
        </Form.Group>
      );
    }

    if (tipo === "textarea") {
      return (
        <Form.Group key={idx} className="mt-3">
          <Form.Label className="fw-bold">{label || "Observação:"}</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            maxLength={400}
            value={value}
            placeholder="Adicione observações caso necessário."
            onChange={(e) => handleChange(e.target.value)}
            disabled={modoAdequacao ? !emAdequacaoDesteCampo : disabled}
          />
          <span className="char-limit text-muted small">
            Limite máximo de 400 caracteres
          </span>
        </Form.Group>
      );
    }

    if (tipo === "pdf" || tipo === "xlsx") {
      const docValue = mapHistoricoToInitialValue(historicoItem);
      const isConforme =
        docValue.status === "CONFORME" && docValue.adequacaoRealizada === true;
      let podeEditarPorAdequacao = () => {
        if (emAdequacaoDesteCampo === undefined) {
          return true;
        } else {
          return emAdequacaoDesteCampo;
        }
      };
      const podeEditar =
        modoAdequacao && podeEditarPorAdequacao() && !isConforme;
      return (
        <div key={idx} className="mt-3">
          <UploadSection
            idResposta={idResposta}
            nomeArquivo={campo.nomeArquivo}
            onUpload={(nome, files) => onFileUpload(nome, files)}
            uploadedFiles={uploadedFiles}
            disabled={modoAdequacao ? !emAdequacaoDesteCampo : disabled}
            podeTrocarArquivo={podeEditar}
          />
        </div>
      );
    }

    if (tipo === "radio") {
      const groupName = campoKey.replace(/\s+/g, "-");
      return (
        <Form.Group key={idx} className="mt-3">
          {label && <Form.Label className="fw-bold">{label}</Form.Label>}
          {campo.alternativa?.map((alt, i) => {
            const checked = value === alt.valor;
            return (
              <div
                key={i}
                className="d-flex align-items-start mt-2 flex-column"
              >
                <Form.Check
                  type="radio"
                  name={groupName}
                  label={alt.valor
                    .replace(" (Hi Gestor)", "")
                    .replace(" (Banco)", "")}
                  value={alt.valor}
                  className="me-2"
                  checked={checked}
                  onChange={() => handleChange(alt.valor)}
                  disabled={modoAdequacao ? !emAdequacaoDesteCampo : disabled}
                />
                {alt.link && (
                  <a
                    href={alt.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary text-decoration-none ms-2"
                  >
                    {alt.valor.includes("Hi Gestor")
                      ? "(Hi Gestor)"
                      : "(Banco)"}
                  </a>
                )}
                {alt.campo?.map((subCampo, j) =>
                  renderField(
                    subCampo,
                    `${idx}-${i}-${j}`,
                    `${label}-${alt.valor}`,
                  ),
                )}
              </div>
            );
          })}
        </Form.Group>
      );
    }

    return null;
  };

  const normalizeIdCampoJson = (str) =>
    str
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]/g, "");

  const _key = normalizeIdCampoJson(data.idCampoJson);

  const renderCamposAssociados = () => {
    if (data.id !== 5 || !quantidadeAssociados || quantidadeAssociados <= 0)
      return null;

    const criteriosAssociados = data.criterios.filter((criterio) =>
      criterio.titulo?.toLowerCase().includes("associado"),
    );

    return criteriosAssociados
      .slice(0, quantidadeAssociados)
      .map((criterio, idx) => (
        <div
          key={criterio.titulo}
          className="p-3 mt-3 border border-gray border-3 rounded bg-light"
        >
          <h6>{criterio.titulo}</h6>
          {criterio.campo?.map((campo, campoIdx) =>
            renderField(campo, `${idx}-${campoIdx}`),
          )}
        </div>
      ));
  };

  const slugKey = slugify(data.idCampoJson);
  const historicoItem = historico?.[slugKey];

  const _emAdequacaoDesteCampo =
    modoAdequacao &&
    historico?.[slugKey]?.dataSolicitacao &&
    typeof historico[slugKey].dataSolicitacao === "string";

  return (
    <>
      <Card className={`mb-4 ${hasError ? "error-card" : ""}`}>
        <Card.Body>
          <button
            type="button"
            onClick={handleToggle}
            className="w-100 d-flex justify-content-between align-items-center"
            style={{
              background: "transparent",
              border: "none",
              padding: 0,
              textAlign: "left",
            }}
            aria-expanded={isOpen}
          >
            <div className="d-flex align-items-center gap-2">
              {isOpen ? (
                <FaChevronDown style={{ color: "#6c757d" }} />
              ) : (
                <FaChevronRight style={{ color: "#6c757d" }} />
              )}

              <Card.Title className="fw-bold mb-0">{data.title}</Card.Title>
            </div>

            {data.link ? (
              <a
                href={data.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary text-decoration-none d-flex align-items-center"
                onClick={(e) => e.stopPropagation()}
              >
                <FaEye className="me-2" /> Ver modelo
              </a>
            ) : (
              <span />
            )}
          </button>

          {isOpen && (
            <>
              {data.description && (
                <Card.Text className="fw-bold mt-2">
                  {data.description}
                </Card.Text>
              )}

              <Form>
                {data.criterios.map((criterio, idx) => {
                  const campo = criterio.campo?.[0];

                  if (
                    data.id === 5 &&
                    criterio.titulo?.includes("Quantas empresas associadas") &&
                    campo
                  ) {
                    const idCampo = campo.idCampo || "quantas-empresa";
                    const selected =
                      selectedOptions?.[data.id]?.campos?.[idCampo] ||
                      campo.resposta ||
                      "";

                    const slugKeyCampo = slugify(data.idCampoJson);

                    const emAdequacaoDesteCampo =
                      modoAdequacao &&
                      historico?.[slugKeyCampo]?.dataSolicitacao &&
                      historico?.[slugKeyCampo]?.adequacaoRealizada !== true;

                    return (
                      <Form.Group key={idx} className="mt-3">
                        <Form.Label className="fw-bold">
                          {criterio.titulo}
                        </Form.Label>
                        {campo.alternativa.map((alt, altIdx) => {
                          const label =
                            alt.valor === "10" ? "10 ou mais" : alt.valor;

                          return (
                            <Form.Check
                              key={altIdx}
                              type="radio"
                              name={`quantidade-associados-${data.id}`}
                              label={label}
                              value={alt.valor}
                              checked={selected === alt.valor}
                              onChange={() => {
                                const quantidade = parseInt(alt.valor);
                                setQuantidadeAssociados(quantidade);
                                handleCampoChange(idCampo, alt.valor, data.id);
                              }}
                              disabled={
                                modoAdequacao
                                  ? !emAdequacaoDesteCampo
                                  : disabled
                              }
                            />
                          );
                        })}
                      </Form.Group>
                    );
                  }

                  if (
                    data.id === 5 &&
                    quantidadeAssociados > 0 &&
                    criterio.titulo?.includes("Tipo do documento")
                  ) {
                    return (
                      <div key={idx} className="mt-4">
                        {criterio.campo.map((campo, i) =>
                          renderField(campo, `${idx}-${i}`),
                        )}
                      </div>
                    );
                  }

                  if (
                    data.id === 5 &&
                    criterio.titulo?.toLowerCase().includes("associado")
                  ) {
                    return null;
                  }

                  return criterio.campo?.map((campo, i) =>
                    renderField(campo, `${idx}-${i}`),
                  );
                })}

                {renderCamposAssociados()}
              </Form>
            </>
          )}
        </Card.Body>

        {historicoItem?.dataSolicitacao && (
          <History
            idCampo={slugKey}
            initialValue={mapHistoricoToInitialValue(historicoItem)}
            onChange={onAnalysisChange}
            isSindicato={true}
          />
        )}
      </Card>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Informação</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalContent}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Topic;
